import { useState } from 'react';
import type { StoryAttachment } from '../types/game';

interface ContentActionsProps {
  modalTitle?: string;
  modalContent?: string;
  attachments?: StoryAttachment[];
}

export function ContentActions({ modalTitle, modalContent, attachments = [] }: ContentActionsProps) {
  const [modalOpen, setModalOpen] = useState(false);
  const hasModal = Boolean(modalContent?.trim());
  if (!hasModal && attachments.length === 0) return null;
  return <>
    <div className="content-actions">
      {hasModal && <button className="button button-ghost" onClick={() => setModalOpen(true)}>Leer aquí</button>}
      {attachments.map((attachment) => <a className="button button-ghost" href={attachment.url} key={`${attachment.url}-${attachment.label}`} download={attachment.download ?? true} target={attachment.download ? undefined : '_blank'} rel={attachment.download ? undefined : 'noreferrer'}>{attachment.download === false ? 'Abrir' : 'Descargar'} · {attachment.label}</a>)}
    </div>
    {modalOpen && <div className="modal-backdrop" role="presentation" onMouseDown={() => setModalOpen(false)}><section className="content-modal modal" role="dialog" aria-modal="true" aria-labelledby="content-modal-title" onMouseDown={(event) => event.stopPropagation()}><div className="editor-heading"><h2 id="content-modal-title">{modalTitle || 'Un recuerdo'}</h2><button className="icon-button" aria-label="Cerrar" onClick={() => setModalOpen(false)}>×</button></div><div className="content-modal-body">{modalContent?.split('\n').map((paragraph) => <p key={paragraph}>{paragraph || '\u00a0'}</p>)}</div><button className="button button-primary" onClick={() => setModalOpen(false)}>Cerrar</button></section></div>}
  </>;
}

